import React from 'react';
import memoize from 'memoize-one';
import { BasicActionBtns } from '../../components';

const columns = memoize((clickHandler, canDup) => [
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'FECHA DE CREACIÓN',
    selector: 'created_at',
    sortable: true,
    grow: '1'
  },
  {
    name: 'INICIO',
    selector: 'start_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TÉRMINO',
    selector: 'end_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'PARTICIPANTES',
    selector: 'employee_count',
    sortable: true,
    center: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <BasicActionBtns
        item={item}
        resource="Survey"
        clickHandler={clickHandler}
        disableEdit={item.has_sent_employee_survey !== false}
        extraIcon={canDup && 'copy'}
        extraIconAction="copy"
        extraIconColor="circle-primary"
        extraIconText="Duplicar"
        extraIcon2="people"
        extraIcon2Action="participants"
        extraIcon2Color="circle-primary"
        extraIcon2Text="Participantes"
        disableExtraIcon2={item.send_survey === false}
      />
    ),
    ignoreRowClick: true,
    grow: '1.5',
    minWidth: '220px',
    right: true
  }
]);

export default columns;
